import { PhoneNumberResources } from '../../../../../../Hub/TrainingHub/EnrollmentCard/ProductModal/ProfileUpdateModal/models';
import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';
import { Admin2FAPhoneNumberModel } from '../../models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateAdmin2FANumber: builder.mutation<
      void,
      {
        id: number;
        phoneNumberRequest: Admin2FAPhoneNumberModel;
      }
    >({
      query: ({ id, phoneNumberRequest }) => ({
        url: `v4/admins/${id}/2fa-phoneNumber`,
        method: 'PUT',
        body: { ...phoneNumberRequest },
      }),
      invalidatesTags: ['Admin'],
    }),
    getAdminPhoneNumberFieldSchema: builder.query<PhoneNumberResources, void>({
      query: () => `profile/phonenumbers/form`,
    }),
  }),
});

export const {
  useUpdateAdmin2FANumberMutation,
  useGetAdminPhoneNumberFieldSchemaQuery,
} = apiSlice;
